/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespCollectionsComponents_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespCollectionsModules_viewer$ref: FragmentReference;
export type SbRespCollectionsModules_viewer = {|
  +isCollectionsModuleEnabled: ?boolean,
  +$fragmentRefs: SbRespCollectionsComponents_viewer$ref,
  +$refType: SbRespCollectionsModules_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespCollectionsModules_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isCollectionsModuleEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "BROWSE_COLLECTIONS_MODULES",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"BROWSE_COLLECTIONS_MODULES\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespCollectionsComponents_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a39f65d84db81d7c0cb5a244ad7bce68';
module.exports = node;
